<template>
  <div class="staff-management">
    <!-- 顶部操作栏 -->
    <div class="operation-bar">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-input
            v-model="filterForm.name"
            placeholder="请输入用户名"
            clearable
            @clear="handleSearch"
            @keyup.enter.native="handleSearch"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="handleSearch"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="3">
          <el-select
            v-model="filterForm.role"
            placeholder="角色"
            clearable
            @change="handleSearch"
          >
            <el-option label="管理员" value="admin"></el-option>
            <el-option label="代理" value="agent"></el-option>
            <el-option label="用户" value="user"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="filterForm.vip_type"
            placeholder="会员类型"
            clearable
            @change="handleSearch"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="普通用户" value="normal"></el-option>
            <el-option-group label="魔趣解析会员">
              <el-option label="魔趣解析会员" value="basic"></el-option>
            </el-option-group>
            <el-option-group label="全能高级会员">
              <el-option label="全能高级会员" value="premium"></el-option>
            </el-option-group>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-select
            v-model="filterForm.vip_level"
            placeholder="会员等级"
            clearable
            @change="handleSearch"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="普通用户" :value="0"></el-option>
            <el-option label="天卡会员" :value="1"></el-option>
            <el-option label="周卡会员" :value="2"></el-option>
            <el-option label="月卡会员" :value="3"></el-option>
            <el-option label="年卡会员" :value="4"></el-option>
            <el-option label="永久会员" :value="9"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-input
            v-model="filterForm.reg_ip"
            placeholder="请输入注册IP"
            clearable
            @clear="handleSearch"
            @keyup.enter.native="handleSearch"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="handleSearch"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="6">
          <div class="action-buttons">
            <el-button type="primary" icon="el-icon-plus" @click="handleAdd">
              新增用户
            </el-button>
            <el-button type="success" icon="el-icon-user-solid" @click="handleAddAgent">
              新增代理人员
            </el-button>
            <el-upload
              class="upload-demo"
              action="#"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="handleImportUsers"
              accept=".txt,.csv,.xlsx,.xls"
              :before-upload="beforeUpload">
              <el-button type="warning" icon="el-icon-upload2">
                用户名导入
              </el-button>
            </el-upload>
            <!-- <el-button type="info" icon="el-icon-refresh" @click="handleRefresh">
              刷新
            </el-button> -->
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 数据表格 -->
    <el-table :data="tableData" style="width: 100%" v-loading="loading" border>
      <el-table-column prop="id" label="ID"  sortable></el-table-column>
      <el-table-column prop="name" label="用户名"  sortable></el-table-column>
      <el-table-column prop="role" label="角色" >
        <template slot-scope="scope">
          <el-tag :type="getRoleTagType(scope.row.role)">
            {{ getRoleText(scope.row.role) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="vip_level" label="会员类型" >
        <template slot-scope="scope">
          <el-tag 
            :type="getVipTagType(scope.row)" 
            :effect="getVipTagEffect(scope.row)"
            v-if="scope.row.vip_level > 0"
            class="vip-tag"
          >
            <i :class="getVipIcon(scope.row)"></i>
            {{ getVipTypeLabel(scope.row) }}
          </el-tag>
          <span v-else class="normal-user">
            <i class="el-icon-user"></i>
            普通用户
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="创建时间" sortable></el-table-column>
      <el-table-column prop="last_login" label="最后登录时间"  sortable></el-table-column>
      <el-table-column prop="vip_expiry_formatted" label="会员有效期" >
        <template slot-scope="scope">
          <span v-if="scope.row.vip_level === 0" class="no-vip">-</span>
          <span v-else-if="isForeverVip(scope.row)" class="forever-vip">
            <i class="el-icon-star-on"></i> 永久有效
          </span>
          <span v-else class="vip-expiry">
            <i class="el-icon-time"></i>
            {{ scope.row.vip_expiry_formatted }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="reg_ip" label="注册IP" ></el-table-column>
      <el-table-column label="账号状态" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.is_banned ? 'danger' : 'success'">
            {{ scope.row.is_banned ? '已封禁' : '正常' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="300">
        <template slot-scope="scope">
          <div class="operation-buttons">
            <el-button type="text" size="mini" @click="handleGetUserInfo(scope.row)" class="edit-btn">
              <i class="el-icon-edit"></i>
              修改
            </el-button>
            <el-button type="text" size="mini" @click="handleViewDetail(scope.row)" class="view-btn">
              <i class="el-icon-view"></i>
              详情
            </el-button>
            <el-button
              type="text"
              size="mini"
              @click="handleBanToggle(scope.row)"
              :class="scope.row.is_banned ? 'unban-btn' : 'ban-btn'"
            >
              <i :class="scope.row.is_banned ? 'el-icon-unlock' : 'el-icon-lock'"></i>
              {{ scope.row.is_banned ? '解封' : '封禁' }}
            </el-button>
            <el-button type="text" size="mini" @click="handleDelete(scope.row)" class="delete-btn">
              <i class="el-icon-delete"></i>
              删除
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      >
      </el-pagination>
    </div>

    <!-- 新增用户对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleDialogClose"
      class="user-dialog"
    >
      <el-form :model="formData" :rules="rules" ref="form" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="用户名" prop="name">
              <el-input v-model="formData.name" placeholder="请输入用户名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码" prop="password">
              <el-input
                v-model="formData.password"
                type="password"
                :placeholder="dialogTitle === '修改用户' ? '留空表示不修改密码' : '请输入密码'"
                show-password
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="dialogTitle === '修改用户'">
          <el-col :span="12">
            <el-form-item label="会员类型" prop="vip_type">
              <el-select v-model="formData.vip_type" placeholder="选择会员类型">
                <el-option label="普通用户" value=""></el-option>
                <el-option label="魔趣解析会员" value="basic"></el-option>
                <el-option label="全能高级会员" value="premium"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="会员等级" prop="vip_level">
              <el-select v-model="formData.vip_level" placeholder="选择会员等级">
                <el-option label="普通用户" :value="0"></el-option>
                <el-option label="天卡会员" :value="1"></el-option>
                <el-option label="周卡会员" :value="2"></el-option>
                <el-option label="月卡会员" :value="3"></el-option>
                <el-option label="年卡会员" :value="4"></el-option>
                <el-option label="永久会员" :value="9"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitLoading">
          {{ submitLoading ? '提交中...' : '确 定' }}
        </el-button>
      </div>
    </el-dialog>

    <!-- 新增代理人员对话框 -->
    <el-dialog
      title="新增代理人员"
      :visible.sync="agentDialogVisible"
      width="600px"
      :before-close="handleAgentDialogClose"
      class="agent-dialog"
    >
      <el-form :model="agentFormData" :rules="agentRules" ref="agentForm" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="用户名" prop="name">
              <el-input v-model="agentFormData.name" placeholder="请输入用户名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码" prop="password">
              <el-input
                v-model="agentFormData.password"
                type="password"
                placeholder="请输入密码"
                show-password
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="代理域名" prop="domain">
          <el-input v-model="agentFormData.domain" placeholder="请输入代理域名">
            <template slot="prepend">https://</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="agentDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAgentForm" :loading="agentSubmitLoading">
          {{ agentSubmitLoading ? '提交中...' : '确 定' }}
        </el-button>
      </div>
    </el-dialog>

    <!-- 用户详情对话框 -->
    <el-dialog
      title="用户详情"
      :visible.sync="detailDialogVisible"
      width="800px"
      class="detail-dialog"
    >
      <div class="user-detail" v-if="currentUser">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <label>用户ID：</label>
              <span>{{ currentUser.id }}</span>
            </div>
            <div class="detail-item">
              <label>用户名：</label>
              <span>{{ currentUser.name }}</span>
            </div>
            <div class="detail-item">
              <label>角色：</label>
              <el-tag :type="getRoleTagType(currentUser.role)">
                {{ getRoleText(currentUser.role) }}
              </el-tag>
            </div>
            <div class="detail-item">
              <label>会员类型：</label>
              <el-tag 
                :type="getVipTagType(currentUser)" 
                :effect="getVipTagEffect(currentUser)"
                v-if="currentUser.vip_level > 0"
              >
                {{ getVipTypeLabel(currentUser) }}
              </el-tag>
              <span v-else>普通用户</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <label>注册时间：</label>
              <span>{{ currentUser.created_at }}</span>
            </div>
            <div class="detail-item">
              <label>最后登录：</label>
              <span>{{ currentUser.last_login || '从未登录' }}</span>
            </div>
            <div class="detail-item">
              <label>注册IP：</label>
              <span>{{ currentUser.reg_ip }}</span>
            </div>
            <div class="detail-item">
              <label>会员有效期：</label>
              <span v-if="currentUser.vip_level === 0">-</span>
              <span v-else-if="isForeverVip(currentUser)" class="forever-vip">
                <i class="el-icon-star-on"></i> 永久有效
              </span>
              <span v-else>{{ currentUser.vip_expiry_formatted }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUserList, addUser, deleteUser, updateUser, createAgent, importUserNameData, setUserBanStatus } from "@/api/index.js";
export default {
  name: "StaffManagement",
  data() {
    return {
      loading: false,
      submitLoading: false,
      agentSubmitLoading: false,
      // 筛选表单
      filterForm: {
        name: "",
        role: "",
        vip_type: "",
        vip_level: "",
        reg_ip: "",
      },
      // 表格数据
      tableData: [],
      // 分页信息
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      // 对话框显示控制
      dialogVisible: false,
      dialogTitle: "新增用户",
      detailDialogVisible: false,
      currentUser: null,
      // 表单数据
      formData: {
        name: "",
        password: "",
        vip_type: "",
        vip_level: 0,
      },
      // 表单验证规则
      rules: {
        name: [
          { required: true, message: "用户名不能为空", trigger: "blur" },
          { min: 3, max: 50, message: "用户名长度3-50位", trigger: "blur" },
        ],
        password: [
          {
            validator: (rule, value, callback) => {
              if (this.dialogTitle === "修改用户" && !value) {
                callback();
                return;
              }
              if (!value) {
                callback(new Error("密码不能为空"));
                return;
              }
              if (value.length < 6) {
                callback(new Error("密码长度至少6位"));
                return;
              }
              callback();
            },
            trigger: "blur",
          },
        ],
      },
      // 代理人员对话框显示控制
      agentDialogVisible: false,
      // 代理人员表单数据
      agentFormData: {
        name: "",
        password: "",
        domain: "",
      },
      // 代理人员表单验证规则
      agentRules: {
        name: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          { min: 3, max:50 , message: "长度在 3 到 50 个字符", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, max: 50, message: "长度在 6 到 50 个字符", trigger: "blur" },
        ],
        domain: [
          { required: true, message: "请输入代理域名", trigger: "blur" },
          { pattern: /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: "请输入有效的域名格式", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    // 获取数据列表
    async fetchData() {
      this.loading = true;
      try {
        const res = await getUserList({
          ...this.filterForm,
          page: this.pagination.currentPage,
          pageSize: this.pagination.pageSize
        });
        this.tableData = res.data.data;
        this.pagination.total = res.data.pagination.totalItems;
      } catch (error) {
        this.$message.error("获取数据失败");
      } finally {
        this.loading = false;
      }
    },
    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1;
      this.fetchData();
    },
    // 刷新
    handleRefresh() {
      this.filterForm = {
        name: "",
        role: "",
        vip_type: "",
        vip_level: "",
        reg_ip: "",
      };
      this.pagination.currentPage = 1;
      this.fetchData();
    },
    // 新增用户
    handleAdd() {
      this.dialogTitle = "新增用户";
      this.formData = {
        name: "",
        password: "",
        vip_type: "",
        vip_level: 0,
      };
      this.dialogVisible = true;
    },
    // 查看用户详情
    handleViewDetail(row) {
      this.currentUser = { ...row };
      this.detailDialogVisible = true;
    },
    // 删除用户
    handleDelete(row) {
      this.$confirm("确认删除该用户?", "提示", {
        type: "warning",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(async () => {
          try {
            await deleteUser(row.id);
            this.$message.success("删除成功");
            this.fetchData();
          } catch (error) {
            this.$message.error("删除失败");
          }
        })
        .catch(() => {});
    },
    handleGetUserInfo(row) {
      this.dialogTitle = "修改用户";
      this.formData = {
        name: row.name,
        password: "",
        id: row.id,
        vip_type: row.vip_type || "",
        vip_level: Number.isInteger(parseInt(row.vip_level, 10)) ? parseInt(row.vip_level, 10) : 0,
      };
      this.dialogVisible = true;
    },
    // 封禁/解封用户
    handleBanToggle(row) {
      const targetStatus = row.is_banned ? 0 : 1;
      const actionText = targetStatus ? "封禁" : "解封";

      this.$prompt(`${actionText}原因`, `${actionText}用户：${row.name}`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: row.ban_reason || "",
        inputPlaceholder: targetStatus ? "请输入封禁原因" : "可选，留空将清空原因",
      })
        .then(async ({ value }) => {
          const reason = (value || "").trim();
          if (targetStatus === 1 && !reason) {
            this.$message.warning("封禁用户时请填写原因");
            return;
          }
          try {
            await setUserBanStatus(row.id, {
              is_banned: targetStatus,
              ban_reason: reason,
            });
            this.$message.success(`${actionText}成功`);
            this.fetchData();
          } catch (error) {
            this.$message.error(error.response?.data?.message || `${actionText}失败`);
          }
        })
        .catch(() => {});
    },
    // 提交表单
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true;
          try {
            const payload = { ...this.formData };
            if (this.dialogTitle === "修改用户" && !payload.password) {
              delete payload.password;
            }

            if (this.dialogTitle === "修改用户") {
              await updateUser(payload);
              this.$message.success("修改成功");
            } else {
              await addUser(payload);
              this.$message.success("添加成功");
            }
            this.dialogVisible = false;
            this.fetchData();
          } catch (error) {
            this.$message.error(this.dialogTitle === "修改用户" ? "修改失败" : "添加失败");
          } finally {
            this.submitLoading = false;
          }
        }
      });
    },
    // 对话框关闭前的回调
    handleDialogClose(done) {
      this.$refs.form.resetFields();
      done();
    },
    // 分页相关方法
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.fetchData();
    },
    
    // 新增代理人员
    handleAddAgent() {
      this.agentFormData = {
        name: "",
        password: "",
        domain: "",
      };
      this.agentDialogVisible = true;
    },
    
    // 提交代理人员表单
    submitAgentForm() {
      this.$refs.agentForm.validate(async (valid) => {
        if (valid) {
          this.agentSubmitLoading = true;
          try {
            await createAgent(this.agentFormData);
            this.$message.success("新增代理人员成功");
            this.agentDialogVisible = false;
            this.fetchData();
          } catch (error) {
            this.$message.error("新增代理人员失败");
          } finally {
            this.agentSubmitLoading = false;
          }
        }
      });
    },
    
    // 代理人员对话框关闭前的回调
    handleAgentDialogClose(done) {
      this.$refs.agentForm.resetFields();
      done();
    },
    
    // 获取角色标签类型
    getRoleTagType(role) {
      switch (role) {
        case 'admin':
          return 'danger';
        case 'agent':
          return 'warning';
        case 'user':
        default:
          return 'success';
      }
    },
    
    // 获取角色显示文本
    getRoleText(role) {
      switch (role) {
        case 'admin':
          return '管理员';
        case 'agent':
          return '代理';
        case 'user':
        default:
          return '用户';
      }
    },

    // 获取VIP类型标签（修复逻辑）
    getVipTypeLabel(row) {
      // 修复：vip_level为0才是普通用户
      if (row.vip_level === 0) return '普通用户';
      
      const vipType = row.vip_type || 'basic';
      const isForever = this.isForeverVip(row);
      
      // 修复：basic类型且vip_level不为0才是解析会员
      if (vipType === 'basic' && row.vip_level > 0) {
        return isForever ? '魔趣解析永久会员' : '魔趣解析会员';
      } 
      // 修复：premium类型且vip_level不为0才是全能高级会员
      else if (vipType === 'premium' && row.vip_level > 0) {
        return isForever ? '全能高级永久会员' : '全能高级会员';
      }
      
      // 兼容旧数据
      return isForever ? '永久会员' : `VIP${row.vip_level}`;
    },

    // 获取VIP标签类型（修复逻辑）
    getVipTagType(row) {
      if (row.vip_level === 0) return 'info';
      
      const vipType = row.vip_type || 'basic';
      
      // 修复：只有vip_level不为0才显示对应会员类型
      if (vipType === 'basic' && row.vip_level > 0) {
        return 'primary';
      } else if (vipType === 'premium' && row.vip_level > 0) {
        return 'warning';
      }
      
      return 'success';
    },

    // 获取VIP标签效果
    getVipTagEffect(row) {
      return this.isForeverVip(row) ? 'dark' : 'plain';
    },

    // 获取VIP图标
    getVipIcon(row) {
      if (this.isForeverVip(row)) {
        return 'el-icon-star-on';
      }
      
      const vipType = row.vip_type || 'basic';
      if (vipType === 'premium') {
        return 'el-icon-trophy';
      }
      
      return 'el-icon-medal';
    },

    // 修复：判断是否为永久VIP，应该是vip_level === 9
    isForeverVip(row) {
      return row.vip_level === 9;
    },
        // 文件上传前的验证
        beforeUpload(file) {
      // 验证文件类型
      const allowedTypes = ['text/plain', 'text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
      const isValidType = allowedTypes.includes(file.type) || 
                         file.name.endsWith('.txt') || 
                         file.name.endsWith('.csv') || 
                         file.name.endsWith('.xlsx') || 
                         file.name.endsWith('.xls');
      
      if (!isValidType) {
        this.$message.error('请选择txt、csv或excel文件');
        return false;
      }
      
      // 验证文件大小（限制为10MB）
      const isValidSize = file.size <= 10 * 1024 * 1024;
      if (!isValidSize) {
        this.$message.error('文件大小不能超过10MB');
        return false;
      }
      
      return true;
    },
    
    // 用户名导入（el-upload的onChange事件）
    handleImportUsers(file, fileList) {
      if (!file.raw) {
        return;
      }
      
      this.uploadUserFile(file.raw);
    },
    
    // 上传用户文件
    async uploadUserFile(file) {
      const formData = new FormData();
      formData.append('file', file);
      
      this.loading = true;
      try {
        // 这里需要根据你的API接口调整
        const res = await importUserNameData(formData);
        
        // 模拟API调用
        // await new Promise(resolve => setTimeout(resolve, 2000));
        
        this.$message.success('用户名导入成功');
        this.fetchData(); // 刷新数据
      } catch (error) {
        this.$message.error('用户名导入失败：' + (error.message || '未知错误'));
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.staff-management {
  padding: 20px;
  background: #f8f9fa;
  min-height: calc(100vh - 60px);

  .operation-bar {
    margin-bottom: 20px;
    padding: 24px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border: 1px solid #e8eaec;

    .action-buttons {
      display: flex;
      gap: 12px;
      justify-content: flex-end;
      
      .el-button {
        border-radius: 8px;
        font-weight: 500;
        padding: 10px 20px;
        transition: all 0.3s ease;
        
        &.el-button--primary {
          background: linear-gradient(135deg, #409eff 0%, #66b3ff 100%);
          border: none;
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
          
          &:hover {
            background: linear-gradient(135deg, #337ecc 0%, #5aa3e6 100%);
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
          }
        }
        
        &.el-button--success {
          background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%);
          border: none;
          box-shadow: 0 2px 8px rgba(103, 194, 58, 0.3);
          
          &:hover {
            background: linear-gradient(135deg, #529b2e 0%, #6bb344 100%);
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(103, 194, 58, 0.4);
          }
        }
        
        &.el-button--info {
          background: linear-gradient(135deg, #909399 0%, #b1b3b8 100%);
          border: none;
          box-shadow: 0 2px 8px rgba(144, 147, 153, 0.3);
          
          &:hover {
            background: linear-gradient(135deg, #73767a 0%, #95979c 100%);
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(144, 147, 153, 0.4);
          }
        }
      }
    }
  }

  .pagination-container {
    margin-top: 20px;
    padding: 20px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border: 1px solid #e8eaec;
    text-align: right;
  }

  // 表格样式
  :deep(.el-table) {
    margin-top: 0;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border: 1px solid #e8eaec;
    
    .el-table__header {
      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
      
      th {
        background: transparent !important;
        color: #495057;
        font-weight: 600;
        font-size: 14px;
        border-bottom: 2px solid #dee2e6;
      }
    }
    
    .el-table__body {
      tr {
        transition: all 0.3s ease;
        
        &:hover {
          background: #f8f9fa;
        }
      }
      
      td {
        border-bottom: 1px solid #f1f3f4;
      }
    }
  }

  // 会员标签样式
  .vip-tag {
    font-weight: 500;
    border-radius: 6px;
    padding: 4px 8px;
    
    i {
      margin-right: 4px;
      font-size: 12px;
    }
  }

  .normal-user {
    color: #6c757d;
    font-size: 13px;
    display: inline-flex;
    align-items: center;
    
    i {
      margin-right: 4px;
    }
  }

  .forever-vip {
    color: #e6a23c;
    font-weight: 600;
    
    i {
      margin-right: 4px;
    }
  }

  .vip-expiry {
    color: #495057;
    
    i {
      margin-right: 4px;
      color: #6c757d;
    }
  }

  .no-vip {
    color: #adb5bd;
  }

  // 操作按钮样式
  .edit-btn {
    color: #409eff;
    
    &:hover {
      color: #66b3ff;
      background: rgba(64, 158, 255, 0.1);
    }
  }

  .view-btn {
    color: #67c23a;
    
    &:hover {
      color: #85ce61;
      background: rgba(103, 194, 58, 0.1);
    }
  }

  .ban-btn {
    color: #e6a23c;

    &:hover {
      color: #f0c78a;
      background: rgba(230, 162, 60, 0.12);
    }
  }

  .unban-btn {
    color: #67c23a;

    &:hover {
      color: #85ce61;
      background: rgba(103, 194, 58, 0.12);
    }
  }

  .delete-btn {
    color: #f56c6c;
    
    &:hover {
      color: #f78989;
      background: rgba(245, 108, 108, 0.1);
    }
  }

  // 输入框和选择器样式
  :deep(.el-input) {
    .el-input__inner {
      border-radius: 8px;
      border: 1px solid #e4e7ed;
      transition: all 0.3s ease;
      
      &:focus {
        border-color: #409eff;
        box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
      }
    }
  }

  :deep(.el-select) {
    width: 100%;
    
    .el-input__inner {
      border-radius: 8px;
      border: 1px solid #e4e7ed;
      transition: all 0.3s ease;
      
      &:focus {
        border-color: #409eff;
        box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
      }
    }
  }
  
  :deep(.el-button--text) {
    padding: 8px 12px;
    border-radius: 6px;
    transition: all 0.3s ease;
    font-weight: 500;
    
    &:hover {
      transform: translateY(-1px);
    }
  }

  // 对话框样式优化
  :deep(.el-dialog) {
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
    
    .el-dialog__header {
      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
      border-radius: 12px 12px 0 0;
      padding: 24px 32px;
      border-bottom: 1px solid #e8eaec;
      
      .el-dialog__title {
        font-weight: 600;
        color: #212529;
        font-size: 18px;
      }
    }
    
    .el-dialog__body {
      padding: 32px;
    }
    
    .el-dialog__footer {
      padding: 20px 32px;
      background: #f8f9fa;
      border-radius: 0 0 12px 12px;
      border-top: 1px solid #e8eaec;
    }
  }

  // 表单样式优化
  :deep(.el-form) {
    .el-form-item__label {
      font-weight: 600;
      color: #495057;
      font-size: 14px;
    }
    
    .el-form-item__content {
      .el-input__inner {
        border-radius: 8px;
        padding: 12px 15px;
        
        &:focus {
          border-color: #409eff;
          box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
        }
      }
    }
  }

  // 用户详情样式
  .user-detail {
    .detail-item {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      
      label {
        font-weight: 600;
        color: #495057;
        min-width: 100px;
        margin-right: 12px;
      }
      
      span {
        color: #6c757d;
      }
    }
  }

  // 标签样式优化
  :deep(.el-tag) {
    border-radius: 6px;
    font-weight: 500;
    padding: 6px 12px;
    border: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-width: 80px;
    
    .el-tag__content {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    &.el-tag--primary {
      background: linear-gradient(135deg, #409eff 0%, #66b3ff 100%);
      color: white;
    }
    
    &.el-tag--warning {
      background: linear-gradient(135deg, #e6a23c 0%, #f0c78a 100%);
      color: white;
    }
    
    &.el-tag--success {
      background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%);
      color: white;
    }
    
    &.el-tag--danger {
      background: linear-gradient(135deg, #f56c6c 0%, #f89898 100%);
      color: white;
    }
    
    &.el-tag--info {
      background: linear-gradient(135deg, #909399 0%, #b1b3b8 100%);
      color: white;
    }
    
    &.el-tag--dark {
      background: linear-gradient(135deg, #303133 0%, #606266 100%);
      color: white;
    }
  }
  
  // 修复：操作按钮容器样式
  .operation-buttons {
    display: flex;
    flex-wrap: nowrap;
    gap: 4px;
    align-items: center;
    justify-content: flex-start;
    
    .el-button {
      margin: 0;
      padding: 4px 8px;
      font-size: 12px;
      min-width: auto;
      
      i {
        margin-right: 2px;
        font-size: 12px;
      }
    }
  }
}

// 响应式设计
@media (max-width: 1400px) {
  .staff-management {
    .operation-bar {
      .action-buttons {
        flex-direction: column;
        gap: 8px;
        
        .el-button {
          width: 100%;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .staff-management {
    padding: 15px;
    
    .operation-bar {
      padding: 20px;
      
      .el-row {
        .el-col {
          margin-bottom: 15px;
        }
      }
    }
    
    :deep(.el-table) {
      font-size: 12px;
      
      .el-table__header th {
        padding: 10px 0;
      }
      
      .el-table__body td {
        padding: 10px 0;
      }
    }
    
    :deep(.el-dialog) {
      width: 95% !important;
      margin: 0 auto;
      
      .el-dialog__body {
        padding: 20px;
      }
    }
  }
}


.action-buttons {
  display: flex;
  gap: 10px;
  align-items: center;
}

.upload-demo {
  display: inline-block;
}

.upload-demo .el-upload {
  display: inline-block;
}
</style>